import domContentLoaded from 'dom-content-loaded';
import { throttle } from 'throttle-debounce';

const scrollAnimation = () => {
	const scrollElms = document.querySelectorAll('.js-scrollAnimation'); // 表示させる要素
	const windowHeight = window.innerHeight; // ウインドウの高さ
	const scrollValue = window.pageYOffset; // スクロール量
	const windowOffset = 50; // 表示させる時のオフセット

	for (let i = 0; i < scrollElms.length; i += 1) {
		// 取得した要素のtop値の取得 + スクロール量
		const scrollTop = scrollElms[i].getBoundingClientRect().top + scrollValue;
		if (scrollValue > scrollTop - windowHeight + windowOffset) {
			scrollElms[i].classList.add('is-start');
		}
	}
};

export default () => {
	domContentLoaded(() => {
		scrollAnimation();
	});
	window.addEventListener('load', scrollAnimation);
	window.addEventListener('scroll', throttle(300, () => {
		scrollAnimation();
	}));
	window.addEventListener('resize', throttle(300, () => {
		scrollAnimation();
	}));
};
